__turbopack_context__.v({
  "alert__description": "alert-module-scss-module__Pu9fdq__alert__description",
  "alert__title": "alert-module-scss-module__Pu9fdq__alert__title",
  "alert_container": "alert-module-scss-module__Pu9fdq__alert_container",
  "info_container": "alert-module-scss-module__Pu9fdq__info_container",
});
